import '../components/SoftwareDevelopment/software-development.css'

import Header from "../components/SoftwareDevelopment/Header"

import TransitionPage from '../utils/TransitionPage';
import TechnologyStack from '../components/SoftwareDevelopment/TechnologyStack';
import ChooseService from '../components/SoftwareDevelopment/ChooseService';
import ChooseIndustry from '../components/SoftwareDevelopment/ChooseIndustry';

import { Helmet } from 'react-helmet-async';

const SoftwareDevelopment = () => {
  return (
    <>
      <Helmet>
            <title>AI-Assisted Software Delivery | Advante Digital</title>
            <meta name="description" content="Advante Digital helps companies maintain, modernize, and improve existing software platforms using AI-assisted development, human review, QA, staging, pull requests, and controlled deployment powered by Motionode."/>
            <meta name="keywords" content="software delivery, software maintenance, legacy modernization, backlog acceleration, AI-assisted engineering, staging, QA, pull requests, controlled deployment"/>
      </Helmet>
      <Header />
      <TechnologyStack />
      <ChooseService />
      <ChooseIndustry />
    </>
  );
}

export default TransitionPage (SoftwareDevelopment);